<ng-container *transloco="let t; prefix: scope">
  <div class="grid grid-cols-1 justify-between gap-4 xs:grid-cols-2 lg:flex lg:flex-row">
    @for (group of linkGroups; track $index) {
      <div class="flex flex-col">
        <div class="mb-4 font-medium text-steel-40 lg:mb-8">{{ t(group.title) }}</div>
        @for (link of group.links; track $index) {
          <rma-footer-link class="mb-4 lg:mb-8" [footerLink]="link" theme="primary" />
        }
      </div>
    }
  </div>
</ng-container>
